import React, { useState, useEffect } from 'react';
import store, { templatesAction } from '@apply/adminStore';
import Dialog from '@material-ui/core/Dialog';
import { TemplatesApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { RefreshEvents } from '../../common/SharedEvents';

const EditNotesModal = () => {
    const { isOpen, templateId, notesText = '' } = useSelector((state) => state.templates.editNotesModal);
    const templatesApi = new TemplatesApi.TemplatesApi(applicationInsights);
    const { dispatch } = store;
    const refreshEvents = new RefreshEvents();

    const [notes, set_notes] = useState('');

    const styles = {
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        buttonMarginRight: {
            marginRight: '20px',
        },
        modal: {
            width: 600,
        },
        content: {
            height: 'auto',
            padding: '10px',
        },
    };

    const handleClose = () =>
        dispatch(
            templatesAction.setEditNotesModal({
                editNotesModal: { isOpen: false },
            })
        );

    useEffect(() => {
        set_notes(notesText);
    }, [notesText]);

    const _onSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const postNotes = {
            templateId: templateId,
            notes,
        };

        await templatesApi.saveNotes(postNotes);

        refreshEvents.dispatchRefreshEvent();
        handleClose();
    };

    if (!isOpen) {
        return null;
    }

    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex={-1}
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <form
                            name='brokerForm'
                            onSubmit={(event) => _onSubmit(event)}
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1>Edit Notes</h1>
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                    onClick={handleClose}
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                            <div className='main-content no-search'>
                                <div
                                    className='scrollable-content'
                                    style={styles.content}
                                >
                                    <div className='standard-form'>
                                        <div
                                            className='row'
                                            style={{ marginBottom: '0' }}
                                        >
                                            <div className='columns small-6 large-12 end'>
                                                <label htmlFor='notes'>
                                                    Notes:
                                                    <span className='req'>*</span>
                                                </label>
                                                <textarea
                                                    name='Text1'
                                                    cols={40}
                                                    rows={3}
                                                    className='req'
                                                    value={notes}
                                                    onChange={(event) => set_notes(event.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='button-footer'
                                        style={styles.buttonContainer}
                                    >
                                        <button
                                            style={styles.buttonMarginRight}
                                            type='submit'
                                            className='button primary'
                                            title='Save changes and close'
                                        >
                                            Save
                                        </button>
                                        &nbsp;
                                        <button
                                            type='button'
                                            className='button hollow'
                                            data-dismiss='modal'
                                            onClick={handleClose}
                                            title='Abandon changes and close'
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default EditNotesModal;
